import { render, staticRenderFns } from "./QuotationStandard.vue?vue&type=template&id=22ea3e28&scoped=true"
import script from "./QuotationStandard.vue?vue&type=script&lang=ts"
export * from "./QuotationStandard.vue?vue&type=script&lang=ts"
import style0 from "./QuotationStandard.vue?vue&type=style&index=0&id=22ea3e28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ea3e28",
  null
  
)

export default component.exports